import { Component, input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { EvTimePeriodFilterComponent, ILocalTimePeriodFilter, IRangeToMonth } from "ev-time-period-filter";
import { Subject } from "rxjs";

@Component({
    selector: "time-period",
    templateUrl: "./time-period.component.html",
    styleUrl: "./time-period.component.scss",
    imports: [EvTimePeriodFilterComponent]
})
export class TimePeriodComponent {
    readonly toDateFormControl = input<FormControl<Date>>();
    readonly fromDateFormControl = input<FormControl<Date>>();
    readonly reset = input<Subject<boolean>>();


    defaultValue: ILocalTimePeriodFilter = {
        toDate: null,
        fromDate:null,
        useFromToDate: false,
        numberOfMonthsToShow: 36,
    };

    selectedValue: ILocalTimePeriodFilter = this.defaultValue;

    rangeToMonthListValue = [
      {
        key: 5,
        monthValue: 36,
        unitsDisplay: "år",
        unitsAmountDisplay: "3"
    },
    {
        key: 4,
        monthValue: 12,
        unitsDisplay: "år",
        unitsAmountDisplay: "1",
        initial: true
    },
    {
        key: 3,
        monthValue: 6,
        unitsDisplay: "mnd",
        unitsAmountDisplay: "6"
    },
    {
        key: 2,
        monthValue: 3,
        unitsDisplay: "mnd",
        unitsAmountDisplay: "3"
    },
    {
        key: 1,
        monthValue: 1,
        unitsDisplay: "mnd",
        unitsAmountDisplay: "1"
    },
    {
        key: 0,
        monthValue: 1,
        unitsDisplay: "mnd",
        unitsAmountDisplay: "1",
        hide: true
    },
    ] as IRangeToMonth[];

    onChange(event: any) {                
        if (event.numberOfMonthsToShow != null) {
            const today = new Date();
            const pastDate = new Date(today.getFullYear(), today.getMonth() - event.numberOfMonthsToShow, today.getDate());
            this.toDateFormControl().setValue(today);
            this.fromDateFormControl().setValue(pastDate);
        } else {
            this.toDateFormControl().setValue(event.toDate);
            this.fromDateFormControl().setValue(event.fromDate);
        }
    }
}


